/**
 * .treegrid
 * Bind Tree Grid
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(function()
{
    "use strict";

    // What selector shall we react to?
    var $selector = '.tree';

    // icons to use
    var $icon_open  = 'fa fa-minus';
    var $icon_close = 'fa fa-plus';

    // Initial State expanded|collapsed
    var $initialState = 'collapsed';

    if($($selector).length){
        // Init the Selector
        $($selector)
            .treegrid({
                'expanderExpandedClass': $icon_open,
                'expanderCollapsedClass': $icon_close,
                'initialState': $initialState
            })
            .treegrid('getRootNodes')
            .treegrid('expand');
    }
});
